import { useApi } from '@/api';
import { Page, PageSkeleton, Link } from '@/components';
import HistoricGraphComponent from './TreasuryChartComponent';
import { Heading, LinkWrapper, KpiCard } from '@blockanalitica/ui';

type Treasury = {
  treasury: string;
  treasury_change: string;
  treasury_change_percentage: string;
  treasury_address: string;
};

export default function TreasuryPage() {
  const [data, error] = useApi<Treasury>({
    url: '/treasury/'
  });

  if (error) {
    throw error;
  }

  if (!data) {
    return <PageSkeleton />;
  }
  return (
    <Page title={<Heading>Treasury</Heading>}>
      <LinkWrapper
        to={`/wallets/${data.treasury_address}`}
        // @ts-ignore
        as={Link}
        variant="kpiCardLink">
        <KpiCard
          title="Treasury balance"
          data={data}
          field="treasury"
          options={{
            currency: 'USD',
            trend: true,
            linkArrow: true
          }}
        />
      </LinkWrapper>
      <HistoricGraphComponent />
    </Page>
  );
}
